import React, { type ReactNode } from "react"
import { cn } from "../styles/utils"
import { CloseButton } from "./CloseButton"
import { Text } from "./Text"
import {
  DrawerBackdrop,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  Drawer as GluestackDrawer,
} from "./gluestack/drawer"

export interface DrawerProps {
  isVisible: boolean
  onClose: () => void
  title?: string
  children: ReactNode
  size?: "sm" | "md" | "lg" | "full"
  anchor?: "left" | "right" | "top" | "bottom"
  showCloseButton?: boolean
  footer?: ReactNode
  bodyClassName?: string
  contentClassName?: string
  closeButtonClassName?: string
  footerClassName?: string
  headerClassName?: string
  closeOnBackdropPress?: boolean
}

export const Drawer: React.FC<DrawerProps> = ({
  isVisible,
  onClose,
  title,
  children,
  size = "lg",
  anchor = "bottom",
  showCloseButton = true,
  footer,
  bodyClassName,
  contentClassName,
  closeButtonClassName,
  footerClassName,
  headerClassName,
  closeOnBackdropPress = true,
}) => {
  return (
    <GluestackDrawer
      isOpen={isVisible}
      onClose={onClose}
      size={size}
      anchor={anchor}
    >
      <DrawerBackdrop onPress={closeOnBackdropPress ? onClose : undefined} />
      <DrawerContent className={cn("bg-background-0", contentClassName)}>
        {title && (
          <DrawerHeader
            className={cn(
              "flex-row justify-between items-center p-4 border-b border-outline-200",
              headerClassName,
            )}
          >
            <Text className="text-lg font-bold">{title}</Text>
            {showCloseButton && (
              <CloseButton
                onPress={onClose}
                variant="drawer"
                className={closeButtonClassName}
              />
            )}
          </DrawerHeader>
        )}

        <DrawerBody className={cn("p-4", bodyClassName)}>{children}</DrawerBody>

        {footer && (
          <DrawerFooter
            className={cn("border-t border-gray-200 p-4", footerClassName)}
          >
            {footer}
          </DrawerFooter>
        )}
      </DrawerContent>
    </GluestackDrawer>
  )
}
